import { Image, NavItem } from "react-bootstrap";
import { NavLink } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/Images/Vizlink_logo.png";
import { connect } from "react-redux";
import storage from "../../apis/Storage";
import { useState, useEffect, useRef } from "react";

const getDefaultMenu = (path) => {
  if (
    [
      "vizLinkJobsList",
      "vizLinkShopsOnBoardingDetails",
      "vizLinkShopsList",
      "sectors",
      "SectorBasedReport",
    ].includes(path)
  )
    return "vizLinkShops";
  if (
    ["VFOVisitList", "VFODailyVistSummaries", "VfoTrackReport"].includes(path)
  )
    return "vfoModule";
  if (
    ["RsoDetailsReport", "RsoPerformanceReport", "ShopsDetailReport"].includes(
      path,
    )
  )
    return "reports";
  return null;
};

const VfoSideNavbar = (props) => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const splitLocation = useLocation().pathname.split("/");

  const [openMenu, setOpenMenu] = useState(() =>
    getDefaultMenu(splitLocation[1]),
  );

  useEffect(() => {
    setOpenMenu(getDefaultMenu(splitLocation[1]));
  }, [splitLocation[1]]);

  const toggleMenu = (menuKey) => {
    setOpenMenu((prev) => (prev === menuKey ? null : menuKey));
  };

  const isPermittedPage = (pageUrl) => {
    if (pageUrl) {
      if (props.userRole == "Administrator" || props.userRole == "RsoAdmin")
        return true;
      if (!props.permittedPages) return false;
      const isUserAuthorised = props.permittedPages.find(
        (page) => page.pageUrl === pageUrl,
      );
      if (isUserAuthorised == false || typeof isUserAuthorised == "undefined") {
        return false;
      } else {
        return true;
      }
    } else return false;
  };

  const handleResize = () => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  useEffect(() => {
    // Attach the event listener
    window.addEventListener("resize", handleResize);

    // Detach the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (
      window.$ &&
      typeof window.$('[data-widget="treeview"]').Treeview === "function"
    ) {
      window.$('[data-widget="treeview"]').Treeview("init");
    }
  }, []);

  return (
    <>
      {
        <div className={props.isNavbarOpen ? "sidebar-backdrop" : ""}>
          <aside className="main-sidebar sidebar-sticky sidebar-light-primary elevation-4 sidebar ">
            <div className={props.isNavbarOpen ? "sidebar" : ""}>
              <span className="d-flex align-items-center justify-content-between px-3">
                <a className=" clearfix" href="/dashboard">
                  <Image src={logo} alt="Logo" className="brand-image"></Image>
                </a>
                {windowSize.width < 993 && (
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={props.onClickOutside}
                    // onClick={() => {
                    //   var hamburger = document.getElementById('pushmenu')
                    //   hamburger.click()
                    //   props.onClickOutside()
                    // }}
                  ></button>
                )}
              </span>

              <nav className="mt-2">
                <ul
                  className="nav nav-pills nav-sidebar flex-column"
                  role="menu"
                >
                  {isPermittedPage("/dashboard") && (
                    <NavItem>
                      <NavLink
                        href={void 0}
                        tag={Link}
                        to="/dashboard"
                        className={` ${
                          splitLocation[1] === "dashboard" ? "active" : ""
                        }`}
                      >
                        <p>Dashboard</p>
                      </NavLink>
                    </NavItem>
                  )}
                  <NavItem
                    className={openMenu === "vizLinkShops" ? "menu-open" : ""}
                  >
                    <NavLink
                      href={void 0}
                      onClick={() => toggleMenu("vizLinkShops")}
                      className={` ${
                        splitLocation[1] === "vizLinkJobsList" ||
                        splitLocation[1] === "vizLinkShopsOnBoardingDetails" ||
                        splitLocation[1] === "vizLinkShopsList" ||
                        splitLocation[1] === "sectors" ||
                        splitLocation[1] === "SectorBasedReport"
                          ? "active"
                          : ""
                      }`}
                    >
                      <p>
                        VizLink Shops
                        <i className="right fas fa-angle-left"></i>
                      </p>
                    </NavLink>
                    <ul className="nav nav-treeview">
                      {isPermittedPage("/vizLinkJobsList") && (
                        <NavItem>
                          <NavLink
                            href={void 0}
                            tag={Link}
                            to="/vizLinkJobsList"
                            className={` ${
                              splitLocation[1] === "vizLinkJobsList"
                                ? "active"
                                : ""
                            }`}
                          >
                            <p>Shops Induction Jobs List</p>
                          </NavLink>
                        </NavItem>
                      )}
                      {isPermittedPage("/vizLinkShopsOnBoardingDetails") && (
                        <NavItem>
                          <NavLink
                            href={void 0}
                            tag={Link}
                            to="/vizLinkShopsOnBoardingDetails"
                            className={` ${
                              splitLocation[1] ===
                              "vizLinkShopsOnBoardingDetails"
                                ? "active"
                                : ""
                            }`}
                          >
                            <p>Shops On-Boarding Details</p>
                          </NavLink>
                        </NavItem>
                      )}
                      {isPermittedPage("/vizLinkShopsList") && (
                        <NavItem>
                          <NavLink
                            href={void 0}
                            tag={Link}
                            to="/vizLinkShopsList"
                            className={` ${
                              splitLocation[1] === "vizLinkShopsList"
                                ? "active"
                                : ""
                            }`}
                          >
                            <p>VizLink Shops List</p>
                          </NavLink>
                        </NavItem>
                      )}
                    </ul>
                  </NavItem>
                  <NavItem
                    className={openMenu === "vfoModule" ? "menu-open" : ""}
                  >
                    <NavLink
                      href={void 0}
                      onClick={() => toggleMenu("vfoModule")}
                      className={` ${
                        splitLocation[1] === "VFOVisitList" ||
                        splitLocation[1] === "VFODailyVistSummaries" ||
                        splitLocation[1] === "VfoTrackReport"
                          ? "active"
                          : ""
                      }`}
                    >
                      <p>
                        VFO Module
                        <i className="right fas fa-angle-left"></i>
                      </p>
                    </NavLink>
                    <ul className="nav nav-treeview">
                      {isPermittedPage("/VFOVisitList") && (
                        <NavItem>
                          <NavLink
                            href={void 0}
                            tag={Link}
                            to="/VFOVisitList"
                            className={` ${
                              splitLocation[1] === "VFOVisitList"
                                ? "active"
                                : ""
                            }`}
                          >
                            <p>VFO Visit List</p>
                          </NavLink>
                        </NavItem>
                      )}
                      {isPermittedPage("/VfoTrackReport") && (
                        <NavItem>
                          <NavLink
                            href={void 0}
                            tag={Link}
                            to="/VfoTrackReport"
                            className={` ${
                              splitLocation[1] === "VfoTrackReport"
                                ? "active"
                                : ""
                            }`}
                          >
                            <p>VFO Track Report</p>
                          </NavLink>
                        </NavItem>
                      )}
                    </ul>
                  </NavItem>
                  <NavItem
                    className={openMenu === "reports" ? "menu-open" : ""}
                  >
                    <NavLink
                      href={void 0}
                      onClick={() => toggleMenu("reports")}
                      className={` ${
                        splitLocation[1] === "RsoDetailsReport" ||
                        splitLocation[1] === "RsoPerformanceReport" ||
                        splitLocation[1] === "ShopsDetailReport"
                          ? "active"
                          : ""
                      }`}
                    >
                      <p>
                        Reports
                        <i className="right fas fa-angle-left"></i>
                      </p>
                    </NavLink>
                    <ul className="nav nav-treeview">
                      <NavItem>
                        <NavLink
                          href={void 0}
                          tag={Link}
                          to="/RsoDetailsReport"
                          className={` ${
                            splitLocation[1] === "RsoDetailsReport"
                              ? "active"
                              : ""
                          }`}
                        >
                          <p>Rso Details Report</p>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          href={void 0}
                          tag={Link}
                          to="/RsoPerformanceReport"
                          className={` ${
                            splitLocation[1] === "RsoPerformanceReport"
                              ? "active"
                              : ""
                          }`}
                        >
                          <p>Rso Performance Report</p>
                        </NavLink>
                      </NavItem>
                      <NavItem className="nav-item">
                        <NavLink
                          href={void 0}
                          tag={Link}
                          to="/ShopsDetailReport"
                          className={`nav-link ${
                            splitLocation[1] === "ShopsDetailReport"
                              ? "active"
                              : ""
                          }`}
                        >
                          <p>Shops Detail Report</p>
                        </NavLink>
                      </NavItem>
                    </ul>
                  </NavItem>
                </ul>
              </nav>
            </div>
          </aside>
        </div>
      }
    </>
  );
};

// // get permitted pages from redux
export default connect((state) => ({
  userRole: storage.get("_appUserRole"),
  permittedPages: JSON.parse(storage.get("_userPermissionsList")), ///state.user.permittedPages,
}))(VfoSideNavbar);
